<template>
  <div>
    <v-flex class="d-flex text-center">
      <v-flex class="blue--text font-weight-black headline">
        Market Place Jasa Konstruksi
        <div>Under Construction</div>
      </v-flex>
    </v-flex>

    <v-row class="mt-8 mx-10">
      <v-col cols="12" md="4" sm="6" class="d-flex child-flex">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card
              width="150"
              height="250"
              :elevation="hover ? 12 : 4"
              class="rounded-lg"
            >
              <router-link
                style="text-decoration: none"
                :to="`public-list-vendor`"
              >
                <v-img
                  height="200px"
                  src="../../assets/images/material.jpeg"
                  class="white--text align-end mt-2"
                  contain
                >
                </v-img>
                <v-card-text>
                  <v-flex
                    class="d-flex mt-n1 justify-center subtitle-2 font-weight-bold"
                  >
                    Pemasok & Harga Pasar
                  </v-flex>
                </v-card-text>
              </router-link>
            </v-card>
          </template>
        </v-hover>
      </v-col>

      <v-col cols="12" md="4" sm="6" class="d-flex child-flex">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card
              width="150"
              height="250"
              :elevation="hover ? 12 : 4"
              class="rounded-lg"
            >
              <router-link
                style="text-decoration: none"
                :to="`public-beranda-market-place`"
              >
                <v-img
                  height="200px"
                  src="../../assets/images/peralatan.jpeg"
                  class="white--text align-end mt-1"
                  contain
                >
                </v-img>
                <v-card-text>
                  <v-flex
                    class="d-flex justify-center subtitle-2 font-weight-bold"
                  >
                    Material dan Peralatan
                  </v-flex>
                </v-card-text>
              </router-link>
            </v-card>
          </template>
        </v-hover>
      </v-col>

      <v-col cols="12" md="4" sm="6" class="d-flex child-flex">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card
              width="150"
              height="250"
              :elevation="hover ? 14 : 4"
              class="rounded-lg"
            >
              <router-link
                style="text-decoration: none"
                :to="`public-tenaga-kerja`"
              >
                <v-img
                  src="../../assets/images/tenaga-kerja.jpeg"
                  height="200px"
                  class="white--text align-end mt-2"
                  contain
                >
                </v-img>
                <v-card-text>
                  <v-flex
                    class="d-flex justify-center subtitle-2 font-weight-bold"
                  >
                    Tenaga Kerja
                  </v-flex>
                </v-card-text>
              </router-link>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>

    <v-flex class="d-flex text-center mt-10">
      <v-flex class="mx-10">
        Temukan Informasi mengenai rangkuman kebutuhan bahan baku dan
        proyek-proyek kegiatan yanga di Pangkalanbun pada menu rantai pasok
      </v-flex>
    </v-flex>

    <v-flex class="d-flex text-center mt-10">
      <v-flex class="mx-10 font-weight-black headline">
        Aplikasi Terkait
      </v-flex>
    </v-flex>
  </div>
</template>

<script>
export default {
  name: "MarketplaceMain",
  methods: {
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },
  },
};
</script>

<style scoped>
</style>